/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Phonenumberoptional2Inputs */

const en_phonenumberoptional2 = /** @type {(inputs: Phonenumberoptional2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone Number (Optional)`)
};

const de_phonenumberoptional2 = /** @type {(inputs: Phonenumberoptional2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonnummer (optional)`)
};

/**
* | output |
* | --- |
* | "Phone Number (Optional)" |
*
* @param {Phonenumberoptional2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const phonenumberoptional2 = /** @type {((inputs?: Phonenumberoptional2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Phonenumberoptional2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_phonenumberoptional2(inputs)
	return de_phonenumberoptional2(inputs)
});
export { phonenumberoptional2 as "phoneNumberOptional" }